// extracted by mini-css-extract-plugin
export default {"error":"formErrorMessage_error__58Nt5"};